import {useEffect, useState} from "react";
import {assistantService} from "../../../services/assistantService";
import {Image, Space} from 'antd';
import {
    DownloadOutlined,
    RotateLeftOutlined,
    RotateRightOutlined,
    SwapOutlined,
    UndoOutlined,
    ZoomInOutlined,
    ZoomOutOutlined
} from "@ant-design/icons";

export const ResponsePlot = ({objectId, objectType, imageName}) => {

    const [imageSrc, setImageSrc] = useState(null);

    useEffect(() => {
        assistantService.image(objectType, objectId, imageName).then(response => {
            const imageUrl = URL.createObjectURL(response.data);
            setImageSrc(imageUrl);
        });

    }, [imageName, objectId, objectType]);

    const onDownload = (imageName) => {
        const url = imageSrc;
        fetch(url)
            .then(response => response.blob())
            .then(blob => {
                const blobUrl = URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = imageName;
                document.body.appendChild(link);
                link.click();
                URL.revokeObjectURL(blobUrl);
                link.remove();
            });
    };

    return (
        <div>
            {imageSrc ?
                <Image
                    width={'100%'}
                    src={imageSrc} alt={imageName} style={{maxWidth: "100%"}}
                    preview={
                        {
                            toolbarRender: (
                                _,
                                {
                                    transform: {scale},
                                    actions: {
                                        onFlipY,
                                        onFlipX,
                                        onRotateLeft,
                                        onRotateRight,
                                        onZoomOut,
                                        onZoomIn,
                                        onReset,
                                    },
                                },
                            ) => (
                                <Space size={12} className="toolbar-wrapper">
                                    <DownloadOutlined onClick={() => onDownload(imageName)} title={"Download"}/>
                                    <SwapOutlined rotate={90} onClick={onFlipY}/>
                                    <SwapOutlined onClick={onFlipX}/>
                                    <RotateLeftOutlined onClick={onRotateLeft}/>
                                    <RotateRightOutlined onClick={onRotateRight}/>
                                    <ZoomOutOutlined disabled={scale === 1} onClick={onZoomOut}/>
                                    <ZoomInOutlined disabled={scale === 50} onClick={onZoomIn}/>
                                    <UndoOutlined onClick={onReset}/>
                                </Space>
                            ),
                            onChange: index => {
                                // setCurrent(index);
                            },
                        }
                    }
                    toolbarRender={false}
                /> : <p>Loading...</p>}
        </div>
    );

}